'use client';

import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

// Backend integration point: replace with real funnel analytics API
const funnelData = [
  { stage: 'Visitantes', count: 3847, rate: 100 },
  { stage: 'Leads', count: 1247, rate: 32.4 },
  { stage: 'Interesados', count: 312, rate: 25.0 },
  { stage: 'Compradores', count: 95, rate: 30.4 },
];

const COLORS = ['var(--primary)', '#60A5FA', '#34D399', 'var(--accent)'];

const CustomTooltip = ({
  active,
  payload,
  label,
}: {
  active?: boolean;
  payload?: Array<{ value: number }>;
  label?: string;
}) => {
  if (active && payload && payload.length) {
    const item = funnelData.find((d) => d.stage === label);
    return (
      <div className="bg-elevated border border-border rounded-lg p-3 shadow-card-hover">
        <p className="text-xs font-semibold text-foreground mb-1">{label}</p>
        <p className="text-sm font-bold font-tabular text-primary">
          {payload[0].value.toLocaleString('es-ES')}
        </p>
        {item && item.rate < 100 && (
          <p className="text-2xs text-muted-foreground mt-0.5">
            {item.rate}% del paso anterior
          </p>
        )}
      </div>
    );
  }
  return null;
};

export default function ConversionFunnelChart() {
  return (
    <div className="bg-card border border-border rounded-xl p-5 h-full">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="text-sm font-semibold text-foreground">
            Embudo de Conversión
          </h2>
          <p className="text-xs text-muted-foreground mt-0.5">
            Visitantes → Compradores de dossiers
          </p>
        </div>
        <span className="text-xs text-muted-foreground bg-secondary px-2 py-1 rounded-lg">
          Este mes
        </span>
      </div>

      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={funnelData} barSize={40} margin={{ top: 0, right: 10, left: -20, bottom: 0 }}>
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="var(--border)"
            vertical={false}
          />
          <XAxis
            dataKey="stage"
            tick={{ fill: 'var(--muted-foreground)', fontSize: 11 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fill: 'var(--muted-foreground)', fontSize: 11 }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(255,255,255,0.03)' }} />
          <Bar dataKey="count" radius={[4, 4, 0, 0]}>
            {funnelData.map((entry, index) => (
              <Cell key={`funnel-cell-${entry.stage}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      {/* Drop-off indicators */}
      <div className="grid grid-cols-3 gap-2 mt-4 pt-4 border-t border-border">
        {[
          { label: 'Visita → Lead', rate: '32.4%', color: 'text-primary' },
          { label: 'Lead → Interés', rate: '25.0%', color: 'text-warning' },
          { label: 'Interés → Compra', rate: '30.4%', color: 'text-accent' },
        ].map((item) => (
          <div key={`drop-${item.label}`} className="text-center">
            <p className={`text-sm font-bold font-tabular ${item.color}`}>
              {item.rate}
            </p>
            <p className="text-2xs text-muted-foreground mt-0.5">{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}